
import { mapState } from "vuex";
import SubscribeState from "./SubscribeState.vue";
import SuccessState from "./SuccessState.vue";

export default {
	name: "NewsletterBanner",
	components: {
		SubscribeState,
		SuccessState,
	},
	computed: {
		...mapState("newsletter-banner", [
			"finishedSubscribing",
			"isSubscribing",
		]),
	},
	beforeDestroy() {
		if (this.isSubscribing) {
			this.$store.commit("newsletter-banner/RESET");
		}
	},
};
